/**
 * Limites mínimos de timeout para IA (cliente PWA + edge synap-chat).
 * O script `npm run check:ai-edge-timeout` falha se alguém reduzir estes valores.
 */

/** Streaming synap-chat: agent loop com várias tools + retries Gemini. */
export const AI_EDGE_STREAM_TIMEOUT_MS = 300_000

/** JSON edges (generate-document-draft, synap-chat REST fallback). */
export const AI_EDGE_JSON_TIMEOUT_MS = 300_000

/** Mínimo aceito pelo CI — não reduzir abaixo disto (regressão jul/2026). */
export const AI_EDGE_STREAM_TIMEOUT_MIN_MS = 300_000

/** Mínimo aceito pelo CI — não reduzir abaixo disto (regressão jul/2026). */
export const AI_EDGE_JSON_TIMEOUT_MIN_MS = 300_000
